import { ITimecardDetailDTO, ITimecardPeriodDTO, ITimecardSummaryDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';
import { PeriodTypeEnums } from 'src/shared/enums';
import { getAxiosParams } from 'src/shared/utils';

export default class TimecardRepository extends ESSRepository {
  private static readonly baseRoute = '/timecard';
  private static readonly apiURL = TimecardRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public getPeriods = async (periodType: PeriodTypeEnums): Promise<ITimecardPeriodDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<ITimecardPeriodDTO>>(
        `${TimecardRepository.apiURL}/periods`,
        getAxiosParams({ periodType }),
      );
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getSummary = async (periodId: number): Promise<ITimecardSummaryDTO> => {
    try {
      const { data } = await http.get(`${TimecardRepository.apiURL}/summaries`, getAxiosParams({ periodId }));
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getDetails = async (periodId: number): Promise<ITimecardDetailDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<ITimecardDetailDTO>>(
        `${TimecardRepository.apiURL}/details`,
        getAxiosParams({ periodId }),
      );
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
